
import { ref, computed, defineComponent, toRefs } from 'vue'
import Paginator, { PageState } from 'primevue/paginator'

export default defineComponent({
  components: {
    Paginator
  },
  props: {
    first: {
      type: Number,
      default: 0
    },
    rows: {
      type: Number,
      default: 10
    },
    totalRecords: {
      type: Number,
      default: 0
    },
    rowsPerPageOptions: {
      type: Array,
      default: null
    },
    template: {
      type: String,
    }
  },
  emits: ['onPage'],
  setup(props, { emit }) {
    const first = computed(() => props.first)
    const row = ref(props.rows)
    const rowsPerPageOption = computed(() => props.rowsPerPageOptions as number[] | undefined)
    const total = computed(() => Math.max(props.totalRecords, 1))
    const { template } = toRefs(props)
    const onPage = (event: PageState) => {
      emit('onPage', event)
    }
    return {
      first,
      row,
      total,
      onPage,
      template,
      rowsPerPageOption
    }
  }
})
